module.exports = __webpack_public_path__ + "img/folder.9327c94b.svg";